<section class="use-cases-section">
  <div class="container">
    <div class="section__header">
      <h2 class="section__title">Soluciones para múltiples necesidades</h2>
      <p class="section__subtitle">
        Descubre cómo Zapphira.ai puede transformar diferentes áreas de tu negocio.
      </p>
    </div>
    
    <!-- Filtros por industria / tags -->
    <div class="use-cases__filters">
      <button 
        class="use-cases__filter-btn" 
        ngClass="{'use-cases__filter-btn--active': currentFilter === 'all'}" 
        (click)="filterByTag('all')">
        Todos
      </button>
      <button 
        *ngFor="let tag of allTags" 
        class="use-cases__filter-btn" 
        ngClass="{'use-cases__filter-btn--active': activeTagFilters.includes(tag) || currentFilter === tag}" 
        (click)="filterByTag(tag)">
        {{tag}}
      </button>
    </div>
    
    <!-- Navegación horizontal de casos de uso -->
    <div class="use-cases__carousel-container">
      <!-- Botón de navegación izquierda -->
      <button 
        class="use-cases__nav-btn use-cases__nav-btn--left" 
        [disabled]="carouselPosition <= 0"
        (click)="scrollCarousel('left')">
        <i class="bi bi-chevron-left"></i>
      </button>
      
      <!-- Carrusel de casos de uso -->
      <div class="use-cases__carousel" #useCasesCarousel>
        <div 
          class="use-case" 
          *ngFor="let useCase of filteredUseCases; let i = index"
          ngClass="{'use-case--active': selectedUseCaseId === useCase.id}">
          <div class="use-case__inner" (click)="selectUseCase(useCase.id)">
            <div class="use-case__icon">
              <i class="{{useCase.icon}}"></i>
            </div>
            <div class="use-case__content">
              <div class="use-case__tags">
                <span 
                  *ngFor="let tag of useCase.tags" 
                  class="use-case__tag"
                  ngClass="{'use-case__tag--active': activeTagFilters.includes(tag) || currentFilter === tag}">
                  {{tag}}
                </span>
              </div>
              <h3 class="use-case__title">{{useCase.title}}</h3>
              <p class="use-case__description">{{useCase.description}}</p>
              <div class="use-case__benefits">
                <div class="use-case__benefit" *ngFor="let benefit of useCase.benefits">
                  <i class="bi bi-check-circle-fill use-case__benefit-icon"></i>
                  <span>{{benefit}}</span>
                </div>
              </div>
              <div class="use-case__actions">
                <!-- <a [routerLink]="['/casos-uso', useCase.id]" class="use-case__link">Ver ejemplo →</a> -->
                <a  class="use-case__link">Ver ejemplo →</a>
                <button class="use-case__demo-btn" (click)="requestDemo(useCase.id, $event)">Solicitar demo</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <!-- Botón de navegación derecha -->
      <button 
        class="use-cases__nav-btn use-cases__nav-btn--right" 
        [disabled]="carouselPosition >= maxCarouselScroll"
        (click)="scrollCarousel('right')">
        <i class="bi bi-chevron-right"></i>
      </button>
    </div>
    
    <!-- Indicadores de paginación (opcional) -->
    <div class="use-cases__pagination">
      <span 
        *ngFor="let useCase of filteredUseCases; let i = index" 
        class="use-cases__pagination-dot"
        ngClass="{'use-cases__pagination-dot--active': i === currentPageIndex}"
        (click)="goToPage(i)">
      </span>
    </div>
    
    <!-- CTA intermedio -->
    <div class="use-cases__cta">
      <h3 class="use-cases__cta-title">¿No encuentras lo que buscas?</h3>
      <p class="use-cases__cta-subtitle">Contáctanos para explorar cómo Zapphira.ai puede adaptarse a tus necesidades específicas.</p>
      <button class="use-cases__cta-btn" (click)="contactSales()">Contactar con ventas</button>
    </div>
    
  </div>
</section>